import { Loader2 } from "lucide-react";

export const SectionTitle = ({ eyebrow, title, subtitle, light, center }) => (
  <div className={`${center ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}`}>
    {eyebrow && (
      <span className={`font-mono text-xs font-bold uppercase tracking-[0.2em] ${light ? "text-[#E8A317]" : "text-[#1E63D6]"}`}>
        {eyebrow}
      </span>
    )}
    <h2 className={`mt-2 font-heading text-3xl font-extrabold uppercase tracking-tight sm:text-4xl ${light ? "text-white" : "text-[#0B2A4A]"}`}>
      {title}
    </h2>
    {subtitle && <p className={`mt-3 text-base leading-relaxed ${light ? "text-slate-300" : "text-slate-600"}`}>{subtitle}</p>}
  </div>
);

export const VerifyBadge = () => (
  <span className="inline-flex items-center rounded-full bg-amber-100 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-amber-800">
    Awaiting verification
  </span>
);

export const Loading = () => (
  <div className="flex items-center justify-center py-24 text-[#0B2A4A]">
    <Loader2 className="h-8 w-8 animate-spin" />
  </div>
);

export const PageHero = ({ title, subtitle, image }) => (
  <section className="relative overflow-hidden bg-[#0B2A4A]">
    {image && <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" />}
    <div className="hero-scrim absolute inset-0" />
    <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
      <h1 className="font-heading text-4xl font-black uppercase tracking-tight text-white sm:text-5xl">{title}</h1>
      {subtitle && <p className="mt-4 max-w-2xl text-lg text-slate-200">{subtitle}</p>}
    </div>
  </section>
);
